export const SCREENS = {
  HOME: `HOME`,
  MESSAGES: `MESSAGES`,
  MARKETPLACE: `MARKETPLACE`,
  FIND_A_DOCTOR: `FIND_A_DOCTOR`,
  ACCOUNT: `ACCOUNT`,
  ADMIN: `ADMIN`,
  LOGOUT: `LOGOUT`,
};
